import { Box, BoxProps } from "@mantine/core";
import clsx from "clsx";

import { DARK_BAND_ATTRIBUTE } from "@/app/(marketing)/constants";

import classes from "./DarkBand.module.css";

interface DarkBandProps extends BoxProps {
  children: React.ReactNode;
}

/**
 * A full-bleed dark section: the homepage's hero, its problem desktop and its
 * close sit on these, with the light sticky stage between them. The attribute
 * turns the header dark while the band is under it.
 */
export default function DarkBand({ children, className, ...props }: DarkBandProps) {
  return (
    <Box
      component="section"
      className={clsx(classes.band, className)}
      {...{ [DARK_BAND_ATTRIBUTE]: true }}
      {...props}
    >
      {children}
    </Box>
  );
}
